import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTT = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M13.537 2.777a24.985 24.985 0 0 0-6.215 4.545 24.982 24.982 0 0 0-4.545 6.216L18.85 31.15l17.612 16.074a24.986 24.986 0 0 0 6.216-4.545 24.983 24.983 0 0 0 4.545-6.215L31.149 18.852 13.537 2.777Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M42.679 42.678a25.158 25.158 0 0 0 2.807-3.341L10.664 4.514a25.142 25.142 0 0 0-6.149 6.15l34.822 34.822a25.148 25.148 0 0 0 3.342-2.808Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M7.322 42.678c7.887 7.887 19.732 9.401 29.14 4.545L2.777 13.537C-2.08 22.945-.565 34.79 7.322 42.678ZM42.678 7.322C34.79-.566 22.945-2.08 13.536 2.776l33.687 33.687c4.856-9.409 3.342-21.254-4.545-29.141Z"
}));
FlagTT.displayName = 'FlagTT';
export default withFlagWrapper(FlagTT);
//# sourceMappingURL=index.js.map